import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Tag, Button, Modal, Empty, Spin, message, Progress } from 'antd';
import { FormOutlined, CheckCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';
import SurveyService from '../../services/SurveyService';
import QoCSurveyForm from './QoCSurveyForm';

export default function QoCSurveyList() {
    const [surveys,      setSurveys]      = useState([]);
    const [loading,      setLoading]      = useState(true);
    const [surveyModal,  setSurveyModal]  = useState(false);
    const [activeSurvey, setActiveSurvey] = useState(null);

    useEffect(() => { load(); }, []);

    const load = () => {
        setLoading(true);
        SurveyService.getPublicSurveys()
            .then(r => setSurveys(r.data?.data || []))
            .catch(e => message.error(e.message))
            .finally(() => setLoading(false));
    };

    const openSurvey = (s) => { setActiveSurvey(s); setSurveyModal(true); };

    if (loading) return <div style={{textAlign:'center',padding:80}}><Spin size="large"/></div>;

    return (
        <div className="page-content">
            <div className="page-head d-flex">
                <div className="my-auto">
                    <h4 style={{margin:0}}>My Surveys</h4>
                    <small className="text-muted">Surveys assigned to you for data collection</small>
                </div>
            </div>
            <div className="page-pad">
                {surveys.length === 0 ? (
                    <Empty description="No surveys assigned to you at this time" style={{padding:60}}/>
                ) : (
                    <Row gutter={[16,16]}>
                        {surveys.map(s => {
                            const submitted = !!s.my_response_id;
                            const draft     = s.my_draft_status === 'draft';
                            return (
                                <Col key={s.id} xs={24} sm={12} md={8}>
                                    <Card size="small" hoverable style={{
                                        borderTop:`3px solid ${submitted?'#16a34a':draft?'#d97706':'#1890ff'}`
                                    }}>
                                        <div style={{fontWeight:700,fontSize:15,marginBottom:4}}>{s.title}</div>
                                        <div style={{fontSize:12,color:'#888',marginBottom:12}}>{s.category} · {s.question_count} questions</div>
                                        {submitted ? (
                                            <Tag color="green" icon={<CheckCircleOutlined/>} style={{width:'100%',textAlign:'center',padding:'6px 0'}}>
                                                Submitted
                                            </Tag>
                                        ) : (
                                            <Button type="primary" block icon={draft?<ClockCircleOutlined/>:<FormOutlined/>}
                                                style={{background:draft?'#d97706':'#1890ff',borderColor:draft?'#d97706':'#1890ff'}}
                                                onClick={()=>openSurvey(s)}>
                                                {draft ? 'Continue Draft' : 'Fill Survey'}
                                            </Button>
                                        )}
                                        {s.period_end && (
                                            <div style={{fontSize:11,color:'#888',marginTop:8,textAlign:'center'}}>
                                                Closes: {s.period_end}
                                            </div>
                                        )}
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                )}
            </div>

            <Modal title={activeSurvey?.title} open={surveyModal}
                onCancel={()=>setSurveyModal(false)} footer={null}
                width={760} destroyOnClose>
                {activeSurvey && (
                    <QoCSurveyForm surveyId={activeSurvey.id}
                        onComplete={()=>{ setSurveyModal(false); load(); }}/>
                )}
            </Modal>
        </div>
    );
}
